/**
 * HudCorners — drops 4 bright-cyan L-shape ticks into the corners of a
 * relatively-positioned element. Used on hero images, intake panels, and
 * any rectangular surface that should feel like a dashboard module.
 *
 * Usage:
 *   <div className="relative ...">
 *     ...
 *     <HudCorners />
 *   </div>
 */
export default function HudCorners({ color = "var(--iw-blue-bright)", size = 12, offset = 12 }) {
  const base = {
    position: "absolute",
    width: `${size}px`,
    height: `${size}px`,
    pointerEvents: "none",
  };
  const o = `${offset}px`;
  return (
    <>
      <span
        aria-hidden
        style={{
          ...base,
          top: o,
          left: o,
          borderTop: `2px solid ${color}`,
          borderLeft: `2px solid ${color}`,
        }}
      />
      <span
        aria-hidden
        style={{
          ...base,
          top: o,
          right: o,
          borderTop: `2px solid ${color}`,
          borderRight: `2px solid ${color}`,
        }}
      />
      <span
        aria-hidden
        style={{
          ...base,
          bottom: o,
          left: o,
          borderBottom: `2px solid ${color}`,
          borderLeft: `2px solid ${color}`,
        }}
      />
      <span
        aria-hidden
        style={{
          ...base,
          bottom: o,
          right: o,
          borderBottom: `2px solid ${color}`,
          borderRight: `2px solid ${color}`,
        }}
      />
    </>
  );
}
